import { Theme } from '@material-ui/core/styles';

export const getMuiButtonBase = (theme: Theme): Record<string, unknown> => ({
  MuiButtonBase: {
    root: {
      '& > .MuiTouchRipple-root': {
        '& > .MuiTouchRipple-rippleVisible': {
          '& > .MuiTouchRipple-child': {
            backgroundColor: theme.palette.grey[300],
          },
        },
      },
    },
  },
});
